module.exports = __webpack_public_path__ + "img/oomuta.64b013b4.jpg";